// @flow
import defaultState from '../defaultState';
import { uniqueById } from '../helpers';
import type {
  Organisation as State,
  CurrentOrganisationActions as Action
} from '../types';

const defaultCurrentOrganisation = defaultState.currentOrganisation;

export default function currentOrganisation(
  state: State = defaultCurrentOrganisation,
  action: Action
) {
  switch (action.type) {
    case 'UPDATE_CURRENT_ORGANISATION':
      return {
        ...defaultCurrentOrganisation,
        ...action.organisation,
        settings: action.organisation.settings
      };

    case 'UPDATE_CURRENT_ORGANISATION_PERMISSIONS':
      return {
        ...state,
        permissions: action.permissions
      };

    case 'UPDATE_CURRENT_ORG_USER_SETTINGS':
      return {
        ...state,
        userSettings: action.settings
      };

    case 'UPDATE_CURRENT_ORG_ALLOCATED_SHAPESETS':
      return {
        ...state,
        shapeSets: {
          ...state.shapeSets,
          allocated: uniqueById(action.shapeSets)
        }
      };

    case 'UPDATE_CURRENT_ORG_UNALLOCATED_SHAPESETS':
      return {
        ...state,
        shapeSets: {
          ...state.shapeSets,
          unallocated: uniqueById(action.shapeSets)
        }
      };

    case 'UPDATE_CURRENT_ORG_ALLOCATED_INSIGHTSETS':
      return {
        ...state,
        insightSets: {
          ...state.insightSets,
          allocated: uniqueById(action.insightSets)
        }
      };

    case 'UPDATE_CURRENT_ORG_UNALLOCATED_INSIGHTSETS':
      return {
        ...state,
        insightSets: {
          ...state.insightSets,
          unallocated: uniqueById(action.insightSets)
        }
      };

    case 'CLEAR_CURRENT_ORGANISATION':
      return defaultCurrentOrganisation;

    case 'LOGOUT':
      return defaultCurrentOrganisation;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/currentOrganisation.js